import { ProviderName } from '@indigohive/cogfy-providers'

export const MAP_COLOR_BY_PROVIDER: Partial<Record<ProviderName, string>> = {
  anthropic: '#1F2937',
  aws: '#FF9900',
  azure: '#007FFF',
  braveSearch: '#FB542B',
  cloudamqp: '#1E90FF',
  deepseek: '#4B0082',
  elevenLabs: '#FF5C00',
  github: '#171515',
  googleAIStudio: '#4285F4',
  googleCalendar: '#1A73E8',
  grok: '#00B9AE',
  groq: '#FF1F1F',
  heroku: '#430098',
  huggingface: '#FFD21F',
  http: '#6B7280',
  infosimples: '#1C3F94',
  jira: '#0052CC',
  lemonfox: '#FFCA28',
  maritaca: '#2E7D32',
  nuvemfiscal: '#0097A7',
  openai: '#10A37F',
  pinecone: '#7342F8',
  postgresql: '#336791',
  sendgrid: '#00B5E2',
  sentry: '#FB4226',
  serper: '#0077B5',
  slack: '#611F69',
  stripe: '#635BFF',
  twilio: '#F22F46',
  typesense: '#FF3E00',
  unstructured: '#6C757D',
  vindi: '#673AB7',
  webflow: '#4353FF',
  whatsapp: '#25D366'
}
